import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer0094 = new TileLayer({
  title: 'Máscara 20151111',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20151111l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0094.setVisible(false);
  
const layer0093 = new TileLayer({
  title: 'Máscara 20151229',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20151229l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0093.setVisible(false);
  
const layer0092 = new TileLayer({
  title: 'Máscara 20160302',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160302l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0092.setVisible(false);
  
const layer0091 = new TileLayer({
  title: 'Máscara 20160521',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160521l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0091.setVisible(false);
  
const layer0090 = new TileLayer({
  title: 'Máscara 20160606',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160606l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0090.setVisible(false);
  
const layer0089 = new TileLayer({
  title: 'Máscara 20160614',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160614l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0089.setVisible(false);
  
const layer0088 = new TileLayer({
  title: 'Máscara 20160622',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160622l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0088.setVisible(false);
  
const layer0087 = new TileLayer({
  title: 'Máscara 20160630',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160630l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0087.setVisible(false);
  
const layer0086 = new TileLayer({
  title: 'Máscara 20160708',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160708l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0086.setVisible(false);
  
const layer0085 = new TileLayer({
  title: 'Máscara 20160716',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160716l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0085.setVisible(false);
  
const layer0084 = new TileLayer({
  title: 'Máscara 20160724',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160724l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0084.setVisible(false);
  
const layer0083 = new TileLayer({
  title: 'Máscara 20160801',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160801l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0083.setVisible(false);
  
const layer0082 = new TileLayer({
  title: 'Máscara 20160809',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160809l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0082.setVisible(false);
 
const layer0081 = new TileLayer({
  title: 'Máscara 20160817',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160817l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0081.setVisible(false);
  
const layer0080 = new TileLayer({
  title: 'Máscara 20160825',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20160825l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer0080.setVisible(false);

export const grupoCapa01_6 = new LayerGroup({
  title: 'Ciclo Hidrológico 2015-2016',
  fold: 'close',
  layers: [layer0080, layer0081, layer0082, layer0083, layer0084, layer0085, layer0086, layer0087, layer0088, layer0089, layer0090, layer0091, layer0092, layer0093, layer0094]
});